<template>
  <!-- 平罗县数字乡村系统，地图图层 -->
  <div id="annglobal">
    <div class="video-container">
      <div class="mapBox">
        <div id="centerMap" class="Map"></div>
        <div class="selectBox">
          <el-radio-group v-model="radio">
            <el-radio
              @click.native.prevent="beautifulPL_clickitem(index, item.name)"
              :label="index"
              v-for="(item, index) in checkList"
              :key="index"
              ><img :src="item.img" v-if="item.img" />
              <p v-else></p>
              {{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="filter"></div>
      <video
        style="margin: 0; padding: 0"
        autoplay
        loop
        muted
        class="fillWidth"
      >
        <source src="../../assets/video/1.mp4" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
import bus from "../../utils/beautifulPlBus.js";
import * as echarts from "echarts";
import JSON from "../../../static/plMap/平罗县乡镇.json"; // 引入平罗县乡镇地图数据
import icon1 from "../../assets/icon/1.png";
import icon2 from "../../assets/icon/2.png";
import icon3 from "../../assets/icon/3.png";
import icon4 from "../../assets/icon/4.png";
export default {
  components: {},
  props: {},
  data() {
    return {
      beautifulData: [],
      myChart: "",
      checkList: [
        {
          name: "全部",
        },
        {
          name: "景区",
          img: require("@/assets/icon/4.png"),
        },
        {
          name: "村镇",
          img: require("@/assets/icon/1.png"),
        },
        {
          name: "产业",
          img: require("@/assets/icon/2.png"),
        },
        {
          name: "其他",
          img: require("@/assets/icon/3.png"),
        },
      ],
      radio: 0,
    };
  },
  created() {
    bus.$on("beautifulPlBusId", (data) => {
      var name = "无用数据";
      this.beautifulPL_clickitem(data, name);
    });
  },
  mounted() {
    this.Anngs();
  },
  methods: {
    drawMap() {
      //地图
      this.myChart = echarts.init(document.getElementById("centerMap"));
      echarts.registerMap("平罗县", JSON); //这个是关键，之前拿到的平罗县各乡镇数据
      let datamap = this.beautifulData;
      var mapOption = {
        geo: {
          type: "map", //图标类型
          map: "平罗县", // 自定义扩展图表类型
          grid: {
            left: "1%",
            right: "1%",
            top: "3%",
            bottom: "20%",
            containLabel: true,
          },
          label: {
            normal: {
              show: true, // 显示省份标签
              textStyle: {
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: 18,
              }, // 省份标签字体颜色
            },
            emphasis: {
              // 对应的鼠标悬浮效果
              show: true,
              textStyle: {
                color: "#ffffff",
              },
            },
          },
          aspectScale: 0.8, //长宽比,默认0.75
          zoom: 1.2,
          roam: false, // 地图是否可以缩放
          itemStyle: {
            normal: {
              borderWidth: 2, // 区域边框宽度
              borderColor: "#00FFCE", // 区域边框颜色
              areaColor: "#15606E", // 区域颜色
            },
            emphasis: {
              borderWidth: 2,
              borderColor: "#00FFCE", // 区域边框颜色
              areaColor: "#15606E", // 区域颜色
            },
          },
        },
        series: [
          {
            data: datamap,
            name: "地图",
            geoIndex: 0,
            coordinateSystem: "geo",
            type: "effectScatter",
            type: "custom",
            renderItem: function (params, api) {
              //具体实现自定义图标的方法
              if (datamap[params.dataIndex].type === "1") {
                return {
                  type: "image",
                  x: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[0],
                  y: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[1],
                  style: {
                    image: icon4,
                    width: 20,
                    height: 19,
                  },
                };
              } else if (datamap[params.dataIndex].type === "2") {
                return {
                  type: "image",
                  x: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[0],
                  y: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[1],
                  style: {
                    image: icon1,
                    width: 20,
                    height: 19,
                  },
                };
              } else if (datamap[params.dataIndex].type === "3") {
                return {
                  type: "image",
                  x: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[0],
                  y: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[1],
                  style: {
                    image: icon2,
                    width: 20,
                    height: 19,
                  },
                };
              } else {
                return {
                  type: "image",
                  x: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[0],
                  y: api.coord([
                    datamap[params.dataIndex].value[0],
                    datamap[params.dataIndex].value[1],
                  ])[1],
                  style: {
                    image: icon3,
                    width: 20,
                    height: 19,
                  },
                };
              }
            },
          },
        ],
        tooltip: {
          trigger: "item",
          position: "top",
          triggerOn: "click",
          formatter: function (params) {
            return params.name;
          },
        },
      };
      // this.myChart.clear();
      this.myChart.setOption(mapOption, true);
      // 以下为自动轮播的方法
      var hourIndex = 0;
      var fhourTime = null;
      let self = this;
      fhourTime = setInterval(function () {
        self.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        self.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: hourIndex,
        });
        self.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: hourIndex,
        });
        hourIndex++;
        if (hourIndex > datamap.length) {
          hourIndex = 0;
        }
        // console.log('11111111')
      }, 6000);
      //鼠标移出恢复轮播
      this.myChart.on("mouseout", function () {
        fhourTime = setInterval(function () {
          self.myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
          });
          self.myChart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: hourIndex,
          });
          self.myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: hourIndex,
          });
          hourIndex++;
          if (hourIndex > datamap.length) {
            hourIndex = 0;
          }
          // console.log('333333')
        }, 6000);
      });
      //鼠标移入停止轮播
      this.myChart.on("mousemove", function (e) {
        clearInterval(fhourTime);
        self.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        self.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
        self.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
        // console.log('2222222')
      });
      this.myChart.on("click", function (params) {
        if (params.data.qjImage) {
          var url = params.data.qjImage;
          window.open(url);
        } else {
        }
      });
    },
    Anngs() {
      Anngs.initScence();
    },
    beautifulPL_clickitem(e, name) {
      if (e === "") {
        // 美丽平罗球体清除
        Anngs.clearItems();
        this.radio = 0;
      } else {
        this.radio = e;
        var json = plDataInterface.beautifuPL_AddLayer(e);
        this.beautifulData = plDataInterface.beautifuPL_AddLayer(e);
        plDataInterface.beautifuPL_RemoveLayer();
        // //美丽平罗球体
        Anngs.updateItems(json);
        // // 清除其它选中
        plDataInterface.digitalManage_RemoveLayer();
        plMap.removeDigitalIndustrial_TilesLayer();
        plDataInterface.digitalServer_RemoveLayer();
        this.$emit("switchs", true);
        this.$emit("setAtter", false);
      }
      this.drawMap();
    },
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
};
</script>
<style lang="less" scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

.video-container .filter {
  z-index: 0;
  position: absolute;
  width: 100vw;
  height: 100vh;
  opacity: 0.3;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #707070;
}
.fillWidth {
  width: 100vw;
  height: 100vh;
  z-index: -1;
  object-fit: fill;
}
.mapBox {
  width: 56.5%;
  height: 75vh;
  z-index: 1;
  position: fixed;
  top: 0px;
  left: 0.625rem;
  right: 0.625rem;
  bottom: 0px;
  margin: auto;
}
.Map {
  width: 56vw;
  height: 75vh;
  position: fixed;
  top: 40px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
}
.tip {
  text-align: center;
  background: url("../../assets/images/foot_logo.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

// 多选框
.selectBox {
  width: 130px;
  height: 150px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: rgba(33, 45, 49, 0.35);
  border: 2px solid #29fcff;
  position: absolute;
  right: 0px;
  bottom: 0px;
  text-align: center;
}
/deep/.el-radio {
  margin-top: 10px;
  color: #ffffff;
  display: block;
  margin-right: 0;
  &::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}
/deep/.el-radio__inner {
  width: 15px;
  height: 15px;
  margin-left: 10px;
  border-radius: 0;
}
/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none;
}
/deep/.el-radio__inner::after {
  width: 0;
  height: 0;
}
/deep/.el-cascader-node > .el-radio,
.el-radio:last-child {
  margin-right: 30px;
}
.text_left {
  text-align: left;
  padding-left: 10px;
}
/deep/.el-radio__label {
  float: left;
}
/deep/.el-radio__input {
  float: right;
}
/deep/.el-cascader-node > .el-radio,
.el-radio:last-child {
  margin-right: 0;
}
/deep/ .el-radio:after {
  clear: both;
  display: block;
  content: "";
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #3ef89c;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #ffffff;
  background: #3ef89c;
}
.selectBox img {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  margin-right: 11px;
}
.selectBox p {
  width: 19px;
  border-radius: 50%;
  margin-right: 11px;
  display: inline-block;
}

// 隐藏滚动条
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/annglobal/annglobal.vue